import { HEADER_HEIGHT } from "@/constants/Layout";
import { createGlobalStyle } from "styled-components";

/**
 * Global styles that set CSS custom properties from JS constants.
 * This allows CSS files to reference the same values as styled-components.
 */
export const GlobalLayoutStyles = createGlobalStyle`
  :root {
    --header-height: ${HEADER_HEIGHT};
  }
`;
